module.exports = __webpack_public_path__ + "img/coin-three-img.582e1222.png";